import React from 'react';
import styled from 'styled-components';
import { Card as AntdCard } from 'antd';
import { CardProps as AntdCardProps } from 'antd/lib/card';
import { Title } from '../Typography';

export interface CardProps extends Omit<AntdCardProps, 'type' | 'title'> {
  title?: React.ReactNode;
  subtitle?: React.ReactNode;
  type?: 'primary' | 'secondary';
}

const StyledPrimaryHeader = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
  margin-bottom: 25px;
`;

export const Card: React.FC<CardProps> = ({
  title,
  subtitle,
  extra,
  type,
  children,
  ...props
}) => {
  const PrimaryCard = (
    <AntdCard {...props}>
      <StyledPrimaryHeader>
        <div>
          {typeof title === 'string' ? (
            <Title level={2} inline>
              {title}
            </Title>
          ) : (
            title
          )}
          {subtitle}
        </div>
        {extra && <div>{extra}</div>}
      </StyledPrimaryHeader>
      <div>{children}</div>
    </AntdCard>
  );

  if (!title && !subtitle) {
    return <AntdCard {...props}>{children}</AntdCard>;
  }

  if (type === 'primary') return PrimaryCard;

  return (
    <AntdCard
      title={
        <>
          {title}
          {subtitle}
        </>
      }
      extra={extra}
      {...props}
    >
      {children}
    </AntdCard>
  );
};

export default styled(Card)``;
